"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { type AIChatActions, AIChatContext, type AIChatContextValue, type AIChatState } from "./contexts";
interface AIChatProviderProps {
  state: AIChatState;
  actions: AIChatActions;
  feedback?: AIChatContextValue["feedback"];
  children: React.ReactNode;
}
export function AIChatProvider(t0) {
  const $ = _c(7);
  const {
    state,
    actions,
    feedback,
    children
  } = t0;
  let t1;
  if ($[0] !== actions || $[1] !== feedback || $[2] !== state) {
    t1 = {
      state,
      actions,
      feedback
    };
    $[0] = actions;
    $[1] = feedback;
    $[2] = state;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const value = t1;
  let t2;
  if ($[4] !== children || $[5] !== value) {
    t2 = <AIChatContext value={value}>{children}</AIChatContext>;
    $[4] = children;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}